import React from 'react';
import { Trans } from 'react-i18next';
import Meta from 'src/components/Meta';
import { HOME } from 'src/routes/routes';
import { withRouter, Link } from 'react-router-dom';
import s from './AccessDeniedPage.styles';

const AccessDeniedPage = () => (
  <s.Container>
    <s.RedBox>
      <Meta title="Access Denied" />
      <s.AccessDeniedText>
        <s.Icon name="hand" /> <Trans>ACCESS_DENIED</Trans>
      </s.AccessDeniedText>
      <s.AccessDeniedSmallText>
        <Trans>ACCESS_DENIES_DESCRIPTION</Trans>
      </s.AccessDeniedSmallText>
      <Link to={HOME}>
        <s.OpenMainPageButton>
          <s.OpenMainPageButtonText>
            <Trans>OPEN_MAIN_PAGE</Trans>
          </s.OpenMainPageButtonText>
        </s.OpenMainPageButton>
      </Link>
    </s.RedBox>
  </s.Container>
);

export default React.memo(withRouter(AccessDeniedPage));
